<!--
 * @Descripttion: 动态表单渲染器
 * @version: 1.0
 * @Author: sakuya
 * @Date: 2021年9月22日09:26:25
 * @LastEditors:
 * @LastEditTime:
-->

<template>
  <el-skeleton v-if="renderLoading || Object.keys(form).length == 0" animated />

  <el-form
    v-else
    ref="form"
    :model="form"
    :disabled="config.disabled"
    :rules="rules"
    :label-width="config.labelWidth"
    :label-position="config.labelPosition"
    v-loading="loading"
    element-loading-text="Loading..."
  >
    <el-row :gutter="24">
      <template v-for="(item, index) in config.formItems" :key="index">
        <el-col :span="item.span || 24" v-if="!hideHandle(item) && !item?.hidden && addHidden(item)">
          <sc-title v-if="item.component == 'title'" :title="item.label"></sc-title>
          <el-form-item v-else :prop="item.name" :rules="rulesHandle(item)">
            <template #label>
              {{ item.label }}
              <el-tooltip v-if="item.tips" :content="item.tips">
                <el-icon><el-icon-question-filled /></el-icon>
              </el-tooltip>
            </template>
            <!-- input -->
            <template v-if="item.component == 'input'">
              <div style="padding: 15px; width: 100%; background-color: #e4e4e4" v-if="item?.options.type == 'html'" v-html="form[item.name]"></div>
              <!-- <el-tag type="primary">
              </el-tag> -->
              <el-input
                v-else
                v-model="form[item.name]"
                :placeholder="item?.options?.placeholder || '请输入' + item.label"
                clearable
                :maxlength="item.options?.maxlength"
                :type="item.options?.type || 'text'"
                :rows="item.options?.rows || 3"
                show-word-limit
                :disabled="disabledFun(item)"
                @keydown.enter="keySubmit"
              ></el-input>
            </template>
            <!-- checkbox -->
            <template v-else-if="item.component == 'checkbox'">
              <template v-if="item.name">
                <el-checkbox v-model="form[item.name][_item.name]" :label="_item.label" v-for="(_item, _index) in item.options.items" :key="_index"></el-checkbox>
              </template>
              <template v-else>
                <el-checkbox v-model="form[_item.name]" :label="_item.label" v-for="(_item, _index) in item.options.items" :key="_index"></el-checkbox>
              </template>
            </template>
            <!-- checkboxGroup -->
            <template v-else-if="item.component == 'checkboxGroup'">
              <el-checkbox-group v-model="form[item.name]">
                <el-checkbox v-for="_item in item.options.items" :key="_item.value" :label="_item.value">{{ _item.label }}</el-checkbox>
              </el-checkbox-group>
            </template>
            <!-- upload -->
            <template v-else-if="item.component == 'upload'">
              <el-col v-for="(_item, _index) in item.options.items" :key="_index">
                <el-form-item :prop="_item.name">
                  <sc-upload v-model="form[_item.name]" :title="_item.label"></sc-upload>
                </el-form-item>
              </el-col>
            </template>
            <!-- multipleUpload -->
            <template v-else-if="item.component == 'multipleUpload'">
              <el-form-item :prop="item.name">
                <sc-upload-multiple v-model="item.options.value" :limit="item.options.limit || 9" :disabled="disabledFun(item)"></sc-upload-multiple>
              </el-form-item>
            </template>
            <!-- timeline -->
            <template v-else-if="item.component == 'timeline'">
              <!-- <el-timeline v-if="form[item.name]?.length > 0 && Array.isArray(form[item.name])" style="max-width: 600px">
                <el-timeline-item
                  v-for="(_item, index) in form[item.name]"
                  :key="index"
                  :color="item.options?.props?.color || '#409eff'"
                  :icon="item.options?.props?.icon || 'el-icon-select'"
                  :type="item.options?.props?.type || 'primary'"
                >
                  {{ form[item.name] }}
                  <h4>
                    {{ item.options.statusText || "审核结果：" }}
                    <el-tag size="large" :type="_item[item.options?.props?.status] == 'approved' ? 'danger' : item.options.statusType">
                      {{ timeline(item.options.items, _item[item.options?.props?.status]) }}
                    </el-tag>
                  </h4>
                  <h4>{{ item.options.titleText || "审核意见：" }}{{ _item[item.options?.props?.title] }}</h4>
                  <p>{{ item.options.subTitleText || "审核时间：" }}{{ _item[item.options?.props?.subTitle] }}</p>
                </el-timeline-item>
              </el-timeline>

              <div v-else>暂无</div> -->
              <DbTimeLine :data="form[item.name]" :item="item" />
            </template>
            <!-- switch -->
            <template v-else-if="item.component == 'switch'">
              <el-switch
                v-model="form[item.name]"
                :active-value="item.options.activeValue"
                :inactive-value="item.options.inactiveValue"
                :active-text="item?.options.activeText"
                :inactive-text="item?.options.inactiveText"
                @change="(e) => switchChange(e, item)"
              />
            </template>
            <!-- select -->
            <template v-else-if="item.component == 'select'">
              <el-select
                v-model="form[item.name]"
                :multiple="item?.options?.multiple"
                :placeholder="item?.options?.placeholder || '请选择' + item.label"
                :disabled="disabledFun(item)"
                clearable
                filterable
                style="width: 100%"
                @change="item?.options?.change && item?.options?.change(form, config.formItems)"
              >
                <el-option
                  v-for="(option, key) in $store.state.dicData.dicData.get(item.options?.remote?.api) || item.options?.items || []"
                  :key="key"
                  :label="option[item.options?.props?.label || 'label']"
                  :value="option[item.options?.props?.value || 'value']"
                ></el-option>
              </el-select>
            </template>
            <!-- cascader -->
            <template v-else-if="item.component == 'cascader'">
              <el-cascader :props="{ multiple: item.options.multiple || false }" v-model="form[item.name]" :options="item.options.items" clearable></el-cascader>
            </template>
            <!-- date -->
            <template v-else-if="item.component == 'date'">
              <el-date-picker
                v-model="form[item.name]"
                :type="item.options.type || 'datetime'"
                :disabled="disabledFun(item)"
                :shortcuts="item.options.shortcuts"
                :default-time="item.options.defaultTime"
                :format="item.options?.format || 'YYYY/MM/DD HH:mm:ss'"
                :value-format="item.options?.valueFormat || 'YYYY-MM-DD HH:mm:ss'"
                :placeholder="item?.options?.placeholder || '请选择'"
                :start-placeholder="item.options.startPlaceholder || '开始时间'"
                :range-separator="item.options.rangeSeparator || '至'"
                :end-placeholder="item.options.endPlaceholder || '结束时间'"
                @change="item?.options?.change"
              ></el-date-picker>
            </template>
            <template v-else-if="item.component == 'timeSelect'">
              <el-date-picker
                v-model="form[item.name]"
                :type="item.options.type || 'datetime'"
                :shortcuts="item.options.shortcuts"
                :default-time="item.options.defaultTime"
                :format="item.options?.format || 'YYYY/MM/DD hh:mm:ss'"
                :value-format="item.options?.valueFormat || 'YYYY-MM-DD hh:mm:ss'"
                :placeholder="item?.options?.placeholder || '请选择'"
                @change="item?.options?.change"
              ></el-date-picker>
            </template>
            <template v-else-if="item.component == 'timePicker'">
              <el-time-picker
                v-model="form[item.name]"
                is-range
                :value-format="item.options?.valueFormat || 'HH:mm:ss'"
                :format="item.options?.format || 'HH:mm:ss'"
                :range-separator="item.options.rangeSeparator || '至'"
                :start-placeholder="item.options.startPlaceholder || '开始时间'"
                :end-placeholder="item.options.endPlaceholder || '结束时间'"
                :default-value="item.options.defaultValue || new Date()"
              />
            </template>
            <template v-else-if="item.component == 'number'">
              <el-input-number v-model="form[item.name]" controls-position="right" :disabled="disabledFun(item)"></el-input-number>
            </template>
            <template v-else-if="item.component == 'map'">
              <MyMap
                :mode="item.options?.editDisabled ? 'view' : 'edit'"
                :latitude="form[item.name][item.options.props?.latitude]"
                :longitude="form[item.name][item.options.props?.longitude]"
                :addressName="form[item.name][item.options.props?.addressName]"
                @selectAddress="(e) => selectAddress(e, item)"
              ></MyMap>
            </template>
            <!-- radio -->
            <template v-else-if="item.component == 'radio'">
              <el-radio-group v-model="form[item.name]">
                <el-radio v-for="_item in item.options.items" :key="_item.value" :label="_item.value">{{ _item.label }}</el-radio>
              </el-radio-group>
            </template>
            <!-- color -->
            <template v-else-if="item.component == 'color'">
              <el-color-picker v-model="form[item.name]" />
            </template>
            <!-- rate -->
            <template v-else-if="item.component == 'rate'">
              <el-rate style="margin-top: 6px" v-model="form[item.name]"></el-rate>
            </template>
            <!-- treeSelect -->
            <el-tree-select
              v-else-if="item.component === 'treeSelect'"
              :check-strictly="item.useStrict"
              clearable
              :multiple="item.multiple"
              v-model="form[item.name]"
              show-checkbox
              check-on-click-node
              :placeholder="item?.options?.placeholder || '请选择'"
              :data="item.options.items"
              filterable
            />
            <!-- :data="$store.state.dicData.dicData.get(item.options?.remote?.api)" -->
            <!-- slider -->
            <template v-else-if="item.component == 'slider'">
              <el-slider v-model="form[item.name]" :marks="item.options.marks"></el-slider>
            </template>
            <!-- tableselect -->
            <template v-else-if="item.component == 'tableselect'">
              <tableselect-render v-model="form[item.name]" :item="item"></tableselect-render>
            </template>
            <!-- iconInput -->
            <template v-else-if="item.component == 'iconInput'">
              <scIconSelect v-model="form[item.name]" :item="item"></scIconSelect>
            </template>
            <!-- editor -->
            <template v-else-if="item.component == 'editor'">
              <sc-editor v-model="form[item.name]" placeholder="请输入" :height="400"></sc-editor>
            </template>
            <template v-else-if="item.component == 'codeEditor'">
              <sc-code-editor
                :disabled="disabledFun(item)"
                style="width: 100%"
                ref="editor"
                v-model="form[item.name]"
                :mode="item.options.mode || 'json'"
                :height="item?.options?.height || 200"
                @change="editorChange(item.name)"
              ></sc-code-editor>
            </template>
            <template v-else-if="item.component == 'formTable'">
              <sc-form-table ref="table" v-model="form[item.name]" :addTemplate="item.options?.addTemplate || {}" drag-sort :placeholder="item?.options?.placeholder || '请选择'">
                <el-table-column :label="formItem.label" :prop="formItem.name" width="180" v-for="(formItem, formItemIndex) in item?.options?.formItems" :key="formItemIndex">
                  <template #default="formItemScope">
                    <slot v-if="formItem.type == 'input'">
                      <el-input v-model="formItemScope.row[formItem.name]" placeholder="请输入"></el-input>
                    </slot>
                    <slot v-else-if="formItem.type == 'select'">
                      <el-select v-model="formItemScope.row[formItem.name]" :placeholder="'请选择' + formItem.label">
                        <el-option
                          v-for="(selectItem, selectIndex) in $store.state.dicData.dicData.get(formItem.options?.remote?.api)"
                          :key="selectIndex"
                          :label="selectItem[formItem?.options?.label || 'label']"
                          :value="selectItem[formItem?.options?.value || 'value']"
                        ></el-option>
                      </el-select>
                    </slot>
                    <slot v-else-if="formItem.type == 'boolean'">
                      <el-switch v-model="formItemScope.row[formItem.name]" :placeholder="'请选择' + formItem.label"> </el-switch>
                    </slot>
                  </template>
                </el-table-column>
              </sc-form-table>
            </template>
            <!-- noComponent -->
            <template v-else>
              <el-tag type="danger">[{{ item.component }}] Component not found</el-tag>
            </template>
            <div v-if="item.message" class="el-form-item-msg">{{ item.message }}</div>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
  </el-form>
  <el-col :span="5" :offset="18" v-if="showSubmit">
    <el-form-item>
      <slot>
        <el-button type="primary" @click="submit">{{ submitText }}</el-button>
      </slot>
    </el-form-item>
  </el-col>
</template>

<script>
import http from "@/utils/request"
import scIconSelect from "@/components/scIconSelect"
import { defineAsyncComponent } from "vue"
import store from "@/store"
import MyMap from "@/components/map/index"
import DbTimeLine from "@/components/dbTimeLine"
const tableselectRender = defineAsyncComponent(() => import("./items/tableselect"))
const scEditor = defineAsyncComponent(() => import("@/components/scEditor"))

export default {
  props: {
    isAdd: { type: String, default: "新增" },
    modelValue: { type: Object, default: () => {} },
    config: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    submitText: { type: String, default: "提交" },
    showSubmit: { type: Boolean, default: true }
  },
  components: {
    tableselectRender,
    scEditor,
    scIconSelect,
    MyMap,
    DbTimeLine
  },
  data() {
    return {
      form: {},
      rules: {},
      editorInstance: null,
      renderLoading: false
    }
  },
  watch: {
    modelValue() {
      if (this.hasConfig) {
        this.deepMerge(this.form, this.modelValue)
      }
    },
    config() {
      this.render()
    },
    form: {
      handler(val) {
        this.$emit("update:modelValue", val)
      },
      deep: true
    }
  },
  computed: {
    hasConfig() {
      return Object.keys(this.config).length > 0
    },
    hasValue() {
      return Object.keys(this.modelValue).length > 0
    }
  },
  emits: ["submit", "keySubmit", "update:modelValue"],
  created() {},
  mounted() {
    this.initRules()
    if (this.hasConfig) {
      this.render()
    }
  },
  methods: {
    //初始化规则
    initRules() {
      const formItems = this.$TOOL.objCopy(this.config.formItems)
      formItems?.forEach((item) => {
        if (item?.options?.required) {
          this.rules[item.name] = [{ required: true, message: item.message || `${item.label}不能为空`, trigger: "blur" }]
        }
      })
    },
    //构建form对象
    render() {
      this.config.formItems?.forEach((item) => {
        if (item.component == "checkbox") {
          if (item.name) {
            const value = {}
            item.options.items.forEach((option) => {
              value[option.name] = option.value
            })
            this.form[item.name] = value
          } else {
            item.options.items.forEach((option) => {
              this.form[option.name] = option.value
            })
          }
        } else if (item.component == "treeSelect") {
          // if (item.name) {
          //   this.form[item.name] = this.form[item.name] || []
          // }
        } else if (item.component == "number") {
          this.$nextTick(() => {
            if (this.form[item.name]) {
              this.form[item.name] = Number(this.form[item.name])
            } else {
              this.form[item.name] = null
            }
          })
        } else if (item.component == "codeEditor") {
          this.form[item.name] = this.form[item.name] || item.options?.defaultValue
        } else if (item.component == "select") {
          if (item?.options?.isString) {
            this.$nextTick(() => {
              this.form[item.name] = String(this.form[item.name])
            })
          }
        } else if (item.component == "switch") {
          if (item.defaultValue != undefined) {
            this.$nextTick(() => {
              this.form[item.name] = item.options?.defaultValue || item.defaultValue
            })
          }
        } else if (item.component == "upload") {
          if (item.name) {
            const value = {}
            item.options.items?.forEach((option) => {
              value[option.name] = option.value
            })
            this.form[item.name] = value
          } else {
            item.options.items?.forEach((option) => {
              this.form[option.name] = option.value
            })
          }
        } else if (item.component == "multipleUpload") {
          if (item.name) {
            this.$nextTick(() => {
              item.options.value = []
              // console.log(111111111111111111, this.form, item.name)
              const num = this.form[item.name].split(",")
              num?.forEach((url) => {
                item.options.value.push({
                  url,
                  name: url.split("/").pop()
                })
              })
              // console.log("item.options.value", item.options.value)
            })
          }
        } else {
          this.form[item.name] = item.value
        }
      })
      if (this.hasValue) {
        this.form = this.deepMerge(this.form, this.modelValue)
      }
      this.getData()
    },
    //switch切换事件
    switchChange(val, item) {
      console.log(val, item)
      // if (val == true) {
      //   item.options?.activeValue && (this.form[item.name] = item.options.activeValue)
      // } else {
      //   item.options?.inactiveValue && (this.form[item.name] = item.options.inactiveValue)
      // }
      // console.log(11, this.form)
    },
    //控制展示添加编辑展示字段的逻辑处理
    disabledFun(item) {
      if (item.options?.editDisabled && this.isAdd != "新增") {
        return true
      } else {
        return false
      }
    },
    //处理是否隐藏添加时候的字段逻辑处理
    addHidden(item) {
      if (item?.options?.addHidden && this.isAdd == "新增") {
        return false
      } else {
        return true
      }
    },
    editorChange() {
      const coder = this.$refs.editor[0].coder
      let v = coder.getValue()
      console.log(v)
    },
    timeline(data, value) {
      const res = data?.filter((item) => item.value == value)
      return res[0]?.label
    },
    selectAddress(address, item) {
      item.options.selectAddress && item.options.selectAddress(address)
    },
    //处理远程选项数据
    getData() {
      this.renderLoading = true
      let remoteData = []
      this.config.formItems.forEach((item) => {
        if (item.options && item.options.remote) {
          const hasApiData = store._state.data.dicData.dicData.has(item.options.remote.api)
          if (hasApiData) {
            return
          }
          // console.log(11, store)
          let req = http.get(item.options.remote.api, item.options.remote.data).then((res) => {
            let data = res.data.records || res.data || []
            if (item.component == "treeSelect" || item.component == "cascader") {
              item.options.items = this.$TOOL.filterTree(data, item.options.props)
            } else if (item.component == "select") {
              item.options.items = res.data.records || res.data || []
            }
            // console.log(11, res.data, item.options.items)
          })
          remoteData.push(req)
        }
      })
      Promise.all(remoteData).then(() => {
        this.renderLoading = false
      })
    },
    //合并深结构对象
    deepMerge(obj1, obj2) {
      let key
      for (key in obj2) {
        obj1[key] = obj1[key] && obj1[key].toString() === "[object Object]" && obj2[key] && obj2[key].toString() === "[object Object]" ? this.deepMerge(obj1[key], obj2[key]) : (obj1[key] = obj2[key])
      }
      return obj1
      //return JSON.parse(JSON.stringify(obj1))
    },
    //处理动态隐藏
    hideHandle(item) {
      if (item?.hideHandle) {
        const exp = eval(item.hideHandle.replace(/\$/g, "this.form"))
        return exp
      }
      return false
    },
    //处理动态必填
    rulesHandle(item) {
      if (item.requiredHandle) {
        const exp = eval(item.requiredHandle.replace(/\$/g, "this.form"))
        let requiredRule = item.rules.find((t) => "required" in t)
        requiredRule.required = exp
      }
      return item.rules
    },
    //数据验证
    validate(valid, obj) {
      return this.$refs.form.validate(valid, obj)
    },
    scrollToField(prop) {
      return this.$refs.form.scrollToField(prop)
    },
    resetFields() {
      return this.$refs.form.resetFields()
    },
    //回车键提交
    keySubmit() {
      this.$emit("keySubmit", this.form)
    },
    //提交
    submit() {
      // const formItems = this.$TOOL.objCopy(this.config.formItems)
      // formItems?.forEach((item) => {
      //   if (item["required"] && !this.form[item["name"]]) {
      //     flag = false
      //     this.$message.error(`${item["label"]}是必填项`)
      //     return
      //   }
      // })
      console.log(22222, this.form)
      this.$refs.form.validate((valid) => {
        if (valid) {
          for (let i = 0; i < this.config.formItems.length; i++) {
            if (this.config.formItems[i].component == "number" && this.form[this.config.formItems[i].name] != null) {
              this.form[this.config.formItems[i].name] = Number(this.form[this.config.formItems[i].name])
            }
          }
          // console.log(11,this.form)
          // return
          this.$emit("submit", this.form)
        } else {
          this.$message.error(`请填写完整的表单`)
        }
      })
    }
  }
}
</script>

<style></style>
